// Stav mé směny pro středové tlačítko mobilní lišty (194).
// ov = GET /me/overview, ds = GET /daysheet/current (oba smí chybět).
//   working — běží směna (stavba) nebo otevřený den (výkaz); since = začátek
//   draft   — den ukončen, výkaz čeká na vyplnění / byl vrácen
//   ended   — dnes už odpracováno a nic neběží; hours = dnešní hodiny
//   idle    — dnes ještě nepřihlášen
export function shiftStateFrom(ov, ds) {
  const day = ds?.day || null;
  const mode = ds?.mode || "site";
  if (ov?.shift) return { state: "working", since: ov.shift.check_in, mode };
  if (day && day.status === "open") return { state: "working", since: day.started_at, mode };
  if (day && (day.status === "draft" || day.status === "returned")) return { state: "draft", mode };
  const hours = mode === "daysheet" ? Number(ds?.todayHours || 0) : Number(ov?.hours_today || 0);
  if (hours > 0) return { state: "ended", hours, mode };
  return { state: "idle", mode };
}

// „7:05“ — uplynulý čas od začátku směny
export function elapsedHm(fromIso, now = Date.now()) {
  const t = new Date(fromIso).getTime();
  if (!fromIso || Number.isNaN(t)) return "0:00";
  const diff = Math.max(0, now - t);
  const h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000);
  return `${h}:${String(m).padStart(2, "0")}`;
}

// „7,8 h“
export function hoursLabel(h) {
  const v = Math.round((Number(h) || 0) * 10) / 10;
  return `${String(v).replace(".", ",")} h`;
}
